/**
 * Portal routing constants (US-044 AC3).
 *
 * `resolveHomePortal` and the `PortalId` union are NOT defined here — they live
 * in the shared packages (`@livingsyncs/permissions` and `@livingsyncs/types`)
 * so the backend `decide()` (US-045) imports the SAME function, never a twin.
 * This module only adds the frontend-local route-path maps and re-exports the
 * shared symbols for convenience.
 */
import type { PortalId } from "@livingsyncs/types";

export type { PortalId } from "@livingsyncs/types";
export { resolveHomePortal } from "@livingsyncs/permissions";

/** Base path each portal is mounted at in the router. */
export const PORTAL_BASE: Record<PortalId, string> = {
  app: "/",
  admin: "/admin",
  audit: "/audit",
};

/**
 * Where to send a user whose home portal is X (the landing route, which for the
 * app portal is the dashboard, not "/"). Frozen 1:1 to the pre-US-044 redirect
 * behaviour of RoleBasedRedirect / NonAdminRoute.
 */
export const PORTAL_HOME: Record<PortalId | "no-access", string> = {
  app: "/dashboard",
  admin: "/admin",
  audit: "/audit",
  "no-access": "/no-access",
};
